import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMutation } from '@apollo/react-hooks';
import { Formik, Field } from 'formik';
import { Form, Input, Button, Alert, message } from 'antd';
import { FormInputField } from '../FormInputField/FormInputField';
import {
  BankFilled,
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  LinkOutlined
} from '@ant-design/icons';

import validators from '../../validators/validators';
import { mutations } from '../../graphql/graphql';

import Upload from '../Upload';
import { SelectTemplate } from '../Templates/Select';
import AnswerForSpecifications from '../Specifications/AnswerForSpecifications';

const ContractorCreate = props => {
  const [photos, setPhotos] = useState([]);
  const [logo, setLogo] = useState({});
  const [specifications, setSpecifications] = useState([]);
  const [templateId, setTemplateId] = useState('');
  const [CONTRACTOR_CREATE] = useMutation(mutations.CONTRACTOR_CREATE);

  const handleSubmitForm = async (values, actions) => {
    const { name, ceo, about, recommendedBy, phone, email, webSite } = values;
    const { setErrors, setSubmitting } = actions;

    CONTRACTOR_CREATE({
      variables: {
        name,
        ceo,
        phone: phone.toString(),
        email,
        webSite,
        about,
        logo: logo.url,
        photos: photos.map(p => p.url),
        recommendedBy,
        templateId,
        specifications
      }
    }).then(
      res => {
        const { data } = res;
        const { contractorCreate } = data;
        message.success('Builder successfully created');
        setSubmitting(true);
        props.history.push(`/contractor/${contractorCreate.id}`);
      },
      err => {
        const errors = {};
        err.graphQLErrors.map(x => {
          if (x.message.includes('name')) {
            errors.name = 'Company name has already been taken.';
          }
        });
        setSubmitting(false);
        setErrors(errors);
      }
    );
  };

  const onChangeLogo = photos => {
    if (!photos.length) return;
    setLogo(photos[0]);
  };

  return (
    <div
      style={{
        display: 'block',
        width: '100vw',
        height: '100vh',
        padding: 0,
        background: '#ffffff'
      }}
    >
      <Formik
        initialValues={{ recommendedBy: [] }}
        validationSchema={validators.contractor.mainSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => handleSubmitForm(values, actions)}
        render={formikProps => {
          const { errors, isSubmitting, handleSubmit, submitForm } = formikProps;

          return (
            <div style={{ padding: 50 }}>
              {Object.keys(errors).length > 0 && (
                <Alert
                  message={errors.about || errors.ceo || errors.name || errors.logo}
                  type="error"
                  showIcon
                  style={{ marginBottom: '1.05rem', maxWidth: '300px' }}
                />
              )}
              <Form onSubmit={handleSubmit}>
                <Field
                  InputType={Input}
                  component={FormInputField}
                  prefix={<BankFilled />}
                  name="name"
                  placeholder="Company name"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Input}
                  component={FormInputField}
                  prefix={<UserOutlined />}
                  name="ceo"
                  placeholder="CEO"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Input}
                  type="number"
                  component={FormInputField}
                  prefix={<PhoneOutlined />}
                  name="phone"
                  placeholder="Phone number (e.g. 6503330000)"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Input}
                  component={FormInputField}
                  prefix={<MailOutlined />}
                  name="email"
                  placeholder="email"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Input}
                  component={FormInputField}
                  prefix={<LinkOutlined />}
                  name="webSite"
                  placeholder="https://web.site..."
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Upload}
                  component={FormInputField}
                  name="logo"
                  onChange={onChangeLogo}
                  items={logo && logo.uid ? [logo] : []}
                  placeholder="Upload logo"
                  single={true}
                />
                <Field
                  InputType={Input.TextArea}
                  component={FormInputField}
                  name="about"
                  placeholder="About"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Upload}
                  component={FormInputField}
                  name="photos"
                  onChange={setPhotos}
                  items={photos}
                  aspect={1.3}
                  placeholder="Upload photos"
                  crop={true}
                />
                <Field
                  InputType={SelectTemplate}
                  component={FormInputField}
                  name="templateId"
                  onChange={setTemplateId}
                  value={templateId}
                />
                {templateId && (
                  <Field
                    InputType={AnswerForSpecifications}
                    component={FormInputField}
                    name="specifications"
                    onChange={setSpecifications}
                    value={specifications}
                    templateId={templateId}
                    prefix="contractor"
                  />
                )}
                <Form.Item style={{ marginBottom: 'unset' }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isSubmitting}
                    onClick={submitForm}
                  >
                    Create
                  </Button>
                </Form.Item>
              </Form>
            </div>
          );
        }}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

ContractorCreate.propTypes = {
  user: PropTypes.object.isRequired
};

const connectedCreate = connect(mapStateToProps, mapDispatchToProps)(ContractorCreate);

export default connectedCreate;
